import { useContext, useMemo } from "react";
import { ConsignorGroup } from "@prisma/client";
import { mutate } from "swr";
import ComboBox from "@/app/components/ComboBox";
import ConsignorGroupContext from "@/lib/context/ConsignorGroupContext";

interface ConsignorGroupSelectorProps {
    currentGroup: ConsignorGroup | null;
    cocode: string;
}

const ConsignorGroupSelector = ({ cocode, currentGroup }: ConsignorGroupSelectorProps) => {
    const { consignorGroups } = useContext(ConsignorGroupContext);
    const options = useMemo(() => consignorGroups?.map((group: any) => ({
        label: group.name,
        value: group.id.toString()
    })) ?? [], [consignorGroups]);

    const handleSelect = async (value: string, _label: string) => {
        await fetch(`/api/v1/consignors/${cocode}/consignor-group`, {
            method: 'PATCH',
            body: JSON.stringify({
                groupId: value
            })
        })
        mutate('/api/v1/consignors')
        mutate('/api/v1/consignor-groups')
    }

    return (
        <ComboBox
            options={options}
            defaultLabel={currentGroup?.name || ""}
            onSelect={handleSelect}
            noun="group"
        />
    );
};

export default ConsignorGroupSelector;